import React, { useEffect } from "react";
import "./Primary.css";

const Primary = ({ text, action, disabled }) => {
  useEffect(() => {
    const buttons = document.querySelectorAll(".primary");

    buttons.forEach((button) => {
      button.addEventListener("mouseover", () => {
        document.getElementsByClassName(
          "primary__icon"
        )[0].style.backgroundColor = "#000";
        document.getElementsByClassName("primary__icon")[0].style.opacity =
          "0.5";
        document.getElementsByClassName(
          "primary__text"
        )[0].style.backgroundColor = "#5fb4a2";
      });

      button.addEventListener("mouseleave", () => {
        document.getElementsByClassName(
          "primary__icon"
        )[0].style.backgroundColor = "#33323d";
        document.getElementsByClassName("primary__icon")[0].style.opacity =
          "1.0";
        document.getElementsByClassName(
          "primary__text"
        )[0].style.backgroundColor = "#203a4c";
      });
    });
  }, []);

  return (
    <button
      type="button"
      className="primary"
      onClick={action}
      disabled={disabled}
    >
      <div className="primary__icon">
        <img src="/assets/images/icons/down-arrows.svg" />
      </div>
      <div className="primary__text body-2">{text}</div>
    </button>
  );
};

export default Primary;
